import { useMemo } from "react";
import { shallowEqual } from "react-redux";

import { useAppSelector } from "@/store";
import { selectProductsByIds } from "@/store/products/selectors";
import { selectShoppingCartProducts } from "@/store/shoppingCart";

export const useHighestMinRequiredAge = () => {
  const shoppingCartProducts = useAppSelector(selectShoppingCartProducts);

  const shoppingCartProductIds = useMemo(
    () => shoppingCartProducts.map((cartProduct) => cartProduct.productId),
    [shoppingCartProducts],
  );

  const products = useAppSelector(
    (state) => selectProductsByIds(state, shoppingCartProductIds),
    shallowEqual,
  );

  return useMemo(
    () =>
      products && products.length > 0
        ? Math.max(...products.map((p) => p.minAge))
        : 0,
    [products],
  );
};
